<div class="d-flex justify-content-center mb-3 position-relative">
    <img class="img-migration"  src="../../../assets/images/superbid-pending.svg" alt="">
    <i class="material-icons close-icon" (click)="close()">close</i>
</div>

<div class="content-wrapper">
    <div class="content-container d-flex flex-column align-items-center justify-content-center">
        <h4 class="title-migration">Seu cadastro precisa de atenção</h4>
        <span class="description-migration">
            Para finalizar a análise da sua conta, complete a etapa indicada abaixo no cadastro da superbid.
        </span>
    </div>

    <div class="pending-container">
        <div class="pending-content">
            <img src="../../../assets/images/icons/pending-icon.svg" alt="">
            <div class="pending-info">
                <span class="pending-info-title">Pendência:</span>
                <div class="pending-info-description">{{ pendingTypeLabel }}</div>
            </div>
        </div>
    </div>

    <div class="w-100">
        <button class="pending-button" (click)="resolvePending()">
            RESOLVER PENDÊNCIA
        </button>
    </div>

    <span class="pending-text-note">Sua conta permanecerá pendente até a resolução.</span>  
</div>